import React, { useState } from "react";
import { ADMIN_IDS } from "../../constants/permisos";
import { useAuthContext } from "../../context/auth";
import visionaLogo from "../../img/visiona-logo.png";
import wecastLogo from "../../img/wecast-logo.png";
import { ERHeader } from "../ER/components/ERHeader";
import { meses } from "../ER/constants";
import styles from "./stylesERv2.module.scss";

export const ERv2 = () => {
  const { id: userId, pais } = useAuthContext();

  const [selectedYear, setSelectedYear] = useState(2026);
  const [verEnDolares, setVerEnDolares] = useState(false);
  const [verChileYPeru, setVerChileYPeru] = useState(false);
  const [verUltimos12Meses, setVerUltimos12Meses] = useState(false);
  const [verAcumulados, setVerAcumulados] = useState(false);
  const [verUnitEconomics, setVerUnitEconomics] = useState(false);
  const [verInversionActivos, setVerInversionActivos] = useState(false);

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const monthsToShow = currentMonth;

  const logo = pais === "Chile" ? wecastLogo : visionaLogo;
  const moneda = (p) => (p === "Chile" ? "$ " : "S/ ");

  if (!ADMIN_IDS.includes(Number(userId))) return null;

  return (
    <div className={styles.ERWrapper}>
      <ERHeader
        logo={logo}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        verEnDolares={verEnDolares}
        setVerEnDolares={setVerEnDolares}
        verChileYPeru={verChileYPeru}
        setVerChileYPeru={setVerChileYPeru}
        modoCombinado={false}
        pais={pais}
        moneda={moneda}
        isOportunidadesLoading={false}
        varYTDvsYTD={null}
        varYTDvsYTDRegion={null}
        runRateParaMostrar={0}
        runRateAnual={0}
        facturacionUltimos12Meses={0}
        variacionFactParaMostrar={null}
        varYTDvsFull={null}
        varYTDvsFullRegion={null}
        ebitdaRunRateParaMostrar={0}
        variacionEbitdaParaMostrar={null}
        es2026Habilitado={true}
        verUltimos12Meses={verUltimos12Meses}
        setVerUltimos12Meses={setVerUltimos12Meses}
        monthsToShow={monthsToShow}
        onOpenChart={() => {}}
        verAcumulados={verAcumulados}
        setVerAcumulados={setVerAcumulados}
        verUnitEconomics={verUnitEconomics}
        setVerUnitEconomics={setVerUnitEconomics}
        unitEconomicsReady={false}
        verInversionActivos={verInversionActivos}
        setVerInversionActivos={setVerInversionActivos}
      />
      <div className={styles.ER}>
        <table className={styles.tableER}>
          <thead>
            <tr>
              <th className={styles.conceptCell}>Concepto</th>
              {meses.map((m, i) => (
                <th key={i} className={styles.valueCell}>
                  {m}
                </th>
              ))}
              <th className={styles.totalCellHead}>YTD</th>
            </tr>
          </thead>
          <tbody>
            <tr className={styles.facturacionRow}>
              <td className={styles.conceptCell}>FACTURACIÓN</td>
              {meses.map((_, i) => (
                <td key={i}>{i < monthsToShow ? "-" : ""}</td>
              ))}
              <td>-</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
